export default __webpack_public_path__ + "static/media/google-logo.fde23648.svg";